import { useState } from 'react'
import { IdCard } from 'lucide-react'
import { Button } from '../../lib/shadcn/button'
import { Spinner } from '../../lib/shadcn/spinner'
import { toast } from '../../lib/shadcn/sonner'
import { useRecordPrdpCard } from '../../hooks/backend/interviews'
import { formatExpiry } from '../../utils/screening'

// Shown only while the PrDP on file is the paper temporary form and nobody has
// recorded seeing the card. Pressing it closes the Today follow-up; the
// database refuses it for anything that is not a temporary PrDP (0331).
export function PrdpCardButton({
  applicationId,
  validUntil,
  onSaved,
}: {
  applicationId: string
  validUntil: string | null | undefined
  onSaved: () => void
}) {
  const { trigger } = useRecordPrdpCard()
  const [busy, setBusy] = useState(false)
  const until = formatExpiry(validUntil)

  const record = async () => {
    setBusy(true)
    try {
      await trigger({ application_id: applicationId }).result
      toast.success('PrDP card recorded')
      onSaved()
    } catch (err) {
      const msg = err instanceof Error ? err.message : String(err)
      toast.error('Could not record the PrDP card', { description: msg })
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="mt-2 flex flex-wrap items-center gap-2">
      <Button size="sm" variant="outline" onClick={record} disabled={busy}>
        {busy ? <Spinner className="h-3.5 w-3.5" /> : <IdCard className="h-3.5 w-3.5" />}
        I have seen the PrDP card
      </Button>
      {until && <span className="text-xs text-muted-foreground">Needed before {until}</span>}
    </div>
  )
}
